// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2LxOj","icon":"Footer_icon__1szsn","trademark":"Footer_trademark__eUCnx"};